<div [ngStyle]="{ height: height }" class="rich-text-editor-container">
    <ckeditor
        *ngIf="Editor"
        [editor]="Editor"
        [(ngModel)]="editorData"
        [config]="editorConfig"
        [disabled]="disabled"
        (change)="onEditorChange($event)"
        [ngStyle]="{ height: height }"
    ></ckeditor>
</div>
